/* eslint-disable import/no-extraneous-dependencies */
import { Stack } from '@mui/material';
import { Elements } from '@stripe/react-stripe-js';
import { Stripe, StripeElementLocale } from '@stripe/stripe-js';
import InstaSpinner from 'components/InstaSpinner';
import { initializeStripe, stripeOptions } from 'configs/stripeConfig';
import { stripeLocaleMapping } from 'i18n/i18n';
import analyticsService, {
  AppEvent
} from 'infrastructure/serviceHandlers/Analytics/Analytics';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TProps_PaymentScreen } from 'typings';
import { PaymentSetupIntent } from 'services/api/paymentsApi';
import StripeForm from './StripeForm';

function PaymentScreenDemo(props: TProps_PaymentScreen) {
  const { i18n } = useTranslation();
  const {
    submitPurchaseRequest,
    amount,
    isUpgrade,
    isFreeTrial,
    isCancellationAndRefundPolicyAccepted,
    planSelected,
    isPreviewPlan
  } = props;
  const [options, setOptions] = useState(stripeOptions);
  const [loading, setLoading] = useState(true);
  const [stripe, setStripe] = useState<Stripe | null>(null);

  const initializeStripeInstance = async () => {
    const stripeInstance = await initializeStripe();
    setStripe(stripeInstance);
  };

  const stripeLocale =
    stripeLocaleMapping[i18n.language as keyof typeof stripeLocaleMapping] ||
    'en';

  const fetchSetupIntent = async () => {
    try {
      initializeStripeInstance();
      const res = await PaymentSetupIntent();
      const { client_secret } = res.data;

      setOptions({
        ...stripeOptions,
        clientSecret: client_secret,
        locale: stripeLocale as StripeElementLocale
      });

      setLoading(false);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      if (!isFreeTrial && !isUpgrade) {
        analyticsService.trackEvent(AppEvent.SUBSCRIPTION_PURCHASE_FAILURE, {
          stripe_error: err
        });
      } else if (!isFreeTrial && isUpgrade) {
        analyticsService.trackEvent(AppEvent.SUBSCRIPTION_UPGRADE_FAILURE, {
          stripe_error: err
        });
      }

      console.error('stripesetup err', err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSetupIntent();
  }, []);

  if (loading || !stripe)
    return (
      <Stack alignItems="center">
        <InstaSpinner />
      </Stack>
    );

  return (
    <Stack sx={{ m: '0 5px' }}>
      <Elements stripe={stripe} options={options}>
        <StripeForm
          amount={amount}
          isUpgrade={isUpgrade}
          isFreeTrial={isFreeTrial}
          submitPurchaseRequest={submitPurchaseRequest}
          isCancellationAndRefundPolicyAccepted={
            isCancellationAndRefundPolicyAccepted
          }
          planSelected={planSelected}
          isPreviewPlan={isPreviewPlan}
        />
      </Elements>
    </Stack>
  );
}

export default PaymentScreenDemo;
